"use strict";
var ɵngcc0 = require('@angular/core');
var ɵngcc1 = require('@angular/common/http');
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/common/http");
var operators_1 = require("rxjs/operators");
var assets_shared_service_1 = require("./assets-shared.service");
var api_config_1 = require("../api.config");
var i0 = require("@angular/core");
var i1 = require("@angular/common/http");
var i2 = require("../api.config");
var AssetSetsService = /** @class */ (function () {
    function AssetSetsService(http, config) {
        this.http = http;
        this.config = config;
        this.appName = "assets-api";
        this.config = config;
    }
    AssetSetsService.prototype.AddDocumentFileAsync = function (id, addDocumentFileRequest) {
        var body = JSON.stringify(addDocumentFileRequest);
        return this.http.put(this.config.AssetsApiEndpoint + "/api/assetsets/" + id + "/addDocument", body)
            .pipe(operators_1.catchError(assets_shared_service_1.AssetsSharedService.handleError()));
    };
    AssetSetsService.prototype.AddImageFileAsync = function (id, addImageFileRequest) {
        var body = JSON.stringify(addImageFileRequest);
        return this.http.put(this.config.AssetsApiEndpoint + "/api/assetsets/" + id + "/addImage", body)
            .pipe(operators_1.catchError(assets_shared_service_1.AssetsSharedService.handleError()));
    };
    AssetSetsService.prototype.AddVideoFileAsync = function (id, addVideoFileRequest) {
        var body = JSON.stringify(addVideoFileRequest);
        return this.http.put(this.config.AssetsApiEndpoint + "/api/assetsets/" + id + "/addVideo", body)
            .pipe(operators_1.catchError(assets_shared_service_1.AssetsSharedService.handleError()));
    };
    AssetSetsService.prototype.AmendAsync = function (id, amendAssetSetRequest) {
        var body = JSON.stringify(amendAssetSetRequest);
        return this.http.put(this.config.AssetsApiEndpoint + "/api/assetsets/" + id + "/amend", body)
            .pipe(operators_1.catchError(assets_shared_service_1.AssetsSharedService.handleError()));
    };
    AssetSetsService.prototype.CreateNewVersion = function (id, createdByProfileId) {
        var params = new http_1.HttpParams();
        if (createdByProfileId) {
            params = params.set('createdByProfileId', createdByProfileId.toString());
        }
        ;
        return this.http.put(this.config.AssetsApiEndpoint + "/api/assetsets/" + id + "/createNewVersion", null, { params: params })
            .pipe(operators_1.catchError(assets_shared_service_1.AssetsSharedService.handleError()));
    };
    AssetSetsService.prototype.GetAsync = function (id) {
        return this.http.get(this.config.AssetsApiEndpoint + "/api/assetsets/" + id)
            .pipe(operators_1.catchError(assets_shared_service_1.AssetsSharedService.handleError()));
    };
    AssetSetsService.prototype.GetByFileIdAsync = function (assetFileId) {
        return this.http.get(this.config.AssetsApiEndpoint + "/api/assetsets/" + assetFileId + "/fromAssetFile")
            .pipe(operators_1.catchError(assets_shared_service_1.AssetsSharedService.handleError()));
    };
    AssetSetsService.prototype.CreateAsync = function (createAssetSetRequest) {
        var body = JSON.stringify(createAssetSetRequest);
        return this.http.post(this.config.AssetsApiEndpoint + "/api/assetsets", body)
            .pipe(operators_1.catchError(assets_shared_service_1.AssetsSharedService.handleError()));
    };
    AssetSetsService.prototype.CreateFromDeliverableAsync = function (createAssetSetRequest) {
        var body = JSON.stringify(createAssetSetRequest);
        return this.http.post(this.config.AssetsApiEndpoint + "/api/assetsets/fromDeliverable", body)
            .pipe(operators_1.catchError(assets_shared_service_1.AssetsSharedService.handleError()));
    };
    AssetSetsService.prototype.CreateFromDeliverablePhaseAsync = function (createAssetSetRequest) {
        var body = JSON.stringify(createAssetSetRequest);
        return this.http.post(this.config.AssetsApiEndpoint + "/api/assetsets/fromPhase", body)
            .pipe(operators_1.catchError(assets_shared_service_1.AssetsSharedService.handleError()));
    };
    AssetSetsService.prototype.DeleteAsync = function (id) {
        return this.http.delete(this.config.AssetsApiEndpoint + "/api/assetsets/" + id)
            .pipe(operators_1.catchError(assets_shared_service_1.AssetsSharedService.handleError()));
    };
    AssetSetsService.prototype.ListAsync = function (page, pageSize, feedId, templateIds, assetSetIds, assetFileStatuses) {
        var params = new http_1.HttpParams();
        if (page) {
            params = params.set('page', page.toString());
        }
        ;
        if (pageSize) {
            params = params.set('pageSize', pageSize.toString());
        }
        ;
        if (feedId) {
            params = params.set('feedId', feedId.toString());
        }
        ;
        if (templateIds && templateIds.length > 0) {
            var templateIdsString = templateIds.join(',');
            params = params.set('templateIds', templateIdsString);
        }
        ;
        if (assetSetIds && assetSetIds.length > 0) {
            var assetSetIdsString = assetSetIds.join(',');
            params = params.set('assetSetIds', assetSetIdsString);
        }
        ;
        if (assetFileStatuses && assetFileStatuses.length > 0)
            params = params.set('assetFileStatuses', assetFileStatuses.map(function (afs) { return afs.id; }).join(','));
        return this.http.get(this.config.AssetsApiEndpoint + "/api/assetsets/", { params: params })
            .pipe(operators_1.catchError(assets_shared_service_1.AssetsSharedService.handleError()));
    };
    AssetSetsService.prototype.RemoveFileAsync = function (id, removeFileRequest) {
        var body = JSON.stringify(removeFileRequest);
        //return this.http.delete<AssetSet>(`${this.config.AssetsApiEndpoint}/api/assetsets/${id}/removeFile`, body)
        //  .pipe(
        //    catchError(AssetsSharedService.handleError<AssetSet>())
        //  );
        //@angular/common/http does not support body in http.delete hence http.request is used ;
        return this.http.request('DELETE', this.config.AssetsApiEndpoint + "/api/assetsets/" + id + "/removeFile", { body: body })
            .pipe(operators_1.catchError(assets_shared_service_1.AssetsSharedService.handleError()));
    };
    AssetSetsService.prototype.Save = function (template) {
        var body = JSON.stringify(template);
        return this.http.put(this.config.AssetsApiEndpoint + "/api/assetsets/save", body)
            .pipe(operators_1.catchError(assets_shared_service_1.AssetsSharedService.handleError()));
    };
    AssetSetsService.ngInjectableDef = i0.defineInjectable({ factory: function AssetSetsService_Factory() { return new AssetSetsService(i0.inject(i1.HttpClient), i0.inject(i2.API_CONFIG)); }, token: AssetSetsService, providedIn: "root" });
    AssetSetsService = __decorate([ __param(1, core_1.Inject(api_config_1.API_CONFIG)),
        __metadata("design:paramtypes", [http_1.HttpClient, Object])
    ], AssetSetsService);
AssetSetsService.ɵfac = function AssetSetsService_Factory(t) { return new (t || AssetSetsService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(api_config_1.API_CONFIG)); };
AssetSetsService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AssetSetsService, factory: function (t) { return AssetSetsService.ɵfac(t); }, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AssetSetsService, [{
        type: core_1.Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: Object, decorators: [{
                type: core_1.Inject,
                args: [api_config_1.API_CONFIG]
            }] }]; }, null); })();
    return AssetSetsService;
}());
exports.AssetSetsService = AssetSetsService;

